import React, { Component } from "react";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { Link } from "react-router-dom";
import Widget from "../../components/shared/Widget";
class CategoriesWidget extends Component {
  render() {
    return (
      <Widget title={"HESABIM"}>
        <ul>
          <li>
            <Link to={"/hesabim"}>Hesabım</Link>
          </li>
          <li>
            <Link to={"/hesabim/siparislerim"}>Siparişlerim</Link>
          </li>
          <li>
            <Link to={"/hesabim/adreslerim"}>Adreslerim</Link>
          </li>
          <li>
            <Link to={"/hesabim/profilimi-duzenle"}>Profilimi Düzenle</Link>
          </li>
          <li>
            <Link to={"/hesabim/sifremi-guncelle"}>Şifremi Değiştir</Link>
          </li>
          <li>
            <Link to={"/hesabim/siparis-gecmisim"}>Sipariş Geçmişim</Link>
          </li>
          <li>
            <Link
              to={"/cikis-yap"}
              onClick={(e) => {
                e.preventDefault();
                this.props.logOut();
              }}
            >
              Çıkış Yap
            </Link>
          </li>
        </ul>
      </Widget>
    );
  }
}

const mapStateToProps = ({ category, product }) => {
  return { category };
};

const mapDispatchToProps = { logOut };

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesWidget);



// WEBPACK FOOTER //
// ./src/components/shared/AccountWidget.js